export default __webpack_public_path__ + "calender-icon-red.svg";